import { render, staticRenderFns } from "./players.vue?vue&type=template&id=4eabd9bc"
import script from "./players.vue?vue&type=script&lang=js"
export * from "./players.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports